export default {
  items: [
    {
      icon: 'bubble_chart',
      title: 'Business',
      route: 'create-company',
      order: 1,
    },
    {
      icon: 'bubble_chart',
      title: 'Auth Rep',
      route: 'create-customer',
      order: 2,
    },
    {
      icon: 'contacts',
      title: 'Guarantor',
      route: 'create-contacts',
      flag: '!sog8484',
      order: 3,
    },
    {
      icon: 'attach_money',
      title: 'Direct Debit',
      route: 'direct-debit',
      order: 4,
    },
    {
      icon: 'bubble_chart',
      title: 'Residential',
      route: 'create-customer',
      order: 6,
    },
    {
      icon: 'store',
      title: 'Change Address',
      route: 'change-address',
      order: 18,
    },
    {
      icon: 'swap_horizontal_circle',
      title: 'Change Lessee',
      route: 'change-lessee',
      order: 18,
    },
    {
      icon: 'bubble_chart',
      title: 'Fixed Line',
      route: 'create-pstn',
      order: 7,
    },
    {
      icon: 'bubble_chart',
      title: 'IP Voice',
      route: 'create-ipvoice',
      order: 8,
    },
    {
      icon: 'bubble_chart',
      title: 'SIP',
      route: 'create-sip',
      order: 9,
    },
    {
      icon: 'bubble_chart',
      title: 'Teams',
      route: 'create-teams',
      order: 10,
    },
    {
      icon: 'bubble_chart',
      title: 'IP Porting',
      route: 'create-porting',
      order: 11,
    },
    {
      icon: 'bubble_chart',
      title: 'Internet',
      route: 'create-internet',
      order: 12,
    },
    {
      icon: 'bubble_chart',
      title: 'Mobile',
      route: 'create-mobile',
      order: 13,
    },
    {
      icon: 'bubble_chart',
      title: 'Inbound',
      route: 'create-inbound',
      order: 14,
    },
    // {
    //   icon: "bubble_chart",
    //   title: "Inbound",
    //   route: "create-inbound-quote",
    //   order: 14,
    // },
    {
      icon: 'bubble_chart',
      title: 'Hardware',
      route: 'create-hardware/false',
      order: 15,
    },
    {
      icon: 'bubble_chart',
      title: 'Fax',
      route: 'create-fax',
      order: 16,
    },
    {
      icon: 'bubble_chart',
      title: 'Other Charges (Internal)',
      route: 'other-charges',
      order: 17,
    },
    //feature flag
    {
      icon: 'bubble_chart',
      title: 'Other Charges',
      route: 'external-charges',
      order: 18,
    },
    {
      icon: 'bubble_chart',
      title: 'Fax',
      route: 'create-fax-quote',
      order: 19,
    },
    {
      icon: 'bubble_chart',
      title: 'Call Management Console',
      route: 'create-cmc',
      order: 20,
    },
    {
      icon: 'bubble_chart',
      title: 'Attachments',
      route: 'attachments',
      order: 21,
    },
    {
      icon: 'attach_money',
      title: 'Finance Application',
      route: 'create-finance',
      flag: '!sog8484',
      order: 22,
    },
    ,
    {
      icon: 'attach_money',
      title: 'Quote Details',
      route: 'quote-details',
      order: 5,
    },
    {
      icon: 'bubble_chart',
      title: 'Sign and Send',
      route: 'order-summary',
      order: 20,
    },
    {
      icon: 'bubble_chart',
      title: 'Generate Quote',
      route: 'generate-quote',
      order: 21,
    },
  ],
};
